import * as _ from 'lodash';
import { Col, Panel } from 'react-bootstrap';
import { HlaAntigenSelectionForm, HlaDrb345ToggleForm } from '@nkr/components/form/hla';
import { IRecipientProfileHlaInfo, IRecipientProfileHlaValues } from '@nkr/models/index';
import { HlaLocusGroup } from '@nkr/models/hla';

interface IProps {
    data: IRecipientProfileHlaInfo,
    hlaValueList: IRecipientProfileHlaValues[],
    handleHlaChange: (name : string, value : string | number | boolean | null) => void
}

const HLAClass2 = (props: IProps) => {
    const drAntigens = props.hlaValueList.find(x => x.hla == 'DR');
    const dqAntigens = props.hlaValueList.find(x => x.hla == 'DQ');
    const dqaAntigens = props.hlaValueList.find(x => x.hla == 'DQa');
    const dpAntigens = props.hlaValueList.find(x => x.hla == 'DP');
    const dpaAntigens = props.hlaValueList.find(x => x.hla == 'DPa');
    const alleles = props.data.alleles ?? [];

    const handleNumberChange = (e: React.ChangeEvent<HTMLSelectElement & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = parseInt(e.currentTarget.value);
        props.handleHlaChange(name, value);
    };

    const handleBooleanChange = (e: React.ChangeEvent<HTMLSelectElement & HTMLInputElement>) => {
        let name    = e.currentTarget.name;
        let value   = e.currentTarget.value == 'null' ? null : e.currentTarget.value == 'true';
        
        props.handleHlaChange(name, value);
    };

    if (!props.data || props.hlaValueList.length == 0) {
        return <></>
    }

    return (
        <>
            <Col xs={12} lg={6} style={{ display: 'flex', flexDirection: 'column' }}>
                <Panel bsStyle='primary' style={{ borderColor: '#e7f1fa', flex: 1 }}>
                    <Panel.Heading style={{
                        backgroundColor: '#1e3a5f',
                        borderColor: '#1e3a5f',
                        color: '#fff',
                        textTransform: 'uppercase',
                        textAlign: 'center',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        letterSpacing: '1px'
                    }}>
                        HLA Class II
                    </Panel.Heading>
                    <Panel.Body style={{ padding: '6px' }}>

                <HlaAntigenSelectionForm
                    antigen1Name={'hlaDrb1'}
                    antigen1Value={props.data.hlaDrb1}
                    antigen2Name={'hlaDrb2'}
                    antigen2Value={props.data.hlaDrb2}
                    alleles={alleles.filter(x => x.locusGroup == HlaLocusGroup.Drb1)}
                    antigenOptions={drAntigens.antigens}
                    title={'DRB1'}
                    antigenLabel={true}
                    equivalentSignedOff={props.data.hlaDiscrepancyIsEquivalent}
                    handleAntigenChange={handleNumberChange}
                />
                
                <HlaDrb345ToggleForm
                    antigenName={'DR52'}
                    dropdownValue={props.data.hlaHasDr52}
                    dropdownName={'hlaHasDr52'}
                    alleles={alleles.filter(a => a.alleleDetail.startsWith('DRB3'))}
                    hasAlleleData={props.data.hasAlleleData}
                    title={'DRB3'}
                    equivalentSignedOff={props.data.hlaDiscrepancyIsEquivalent}
                    handleBooleanChange={handleBooleanChange}
                />

                <HlaDrb345ToggleForm
                    antigenName={'DR53'}
                    dropdownValue={props.data.hlaHasDr53}
                    dropdownName={'hlaHasDr53'}
                    alleles={alleles.filter(a => a.alleleDetail.startsWith('DRB4'))}
                    hasAlleleData={props.data.hasAlleleData}
                    title={'DRB4'}
                    equivalentSignedOff={props.data.hlaDiscrepancyIsEquivalent}
                    handleBooleanChange={handleBooleanChange}
                />

                <HlaDrb345ToggleForm
                    antigenName={'DR51'}
                    dropdownValue={props.data.hlaHasDr51}
                    dropdownName={'hlaHasDr51'}
                    alleles={alleles.filter(a => a.alleleDetail.startsWith('DRB5'))}
                    hasAlleleData={props.data.hasAlleleData}
                    title={'DRB5'}
                    equivalentSignedOff={props.data.hlaDiscrepancyIsEquivalent}
                    handleBooleanChange={handleBooleanChange}
                />

                <HlaAntigenSelectionForm
                    antigen1Name={'hlaDqa1'}
                    antigen1Value={props.data.hlaDqa1}
                    antigen2Name={'hlaDqa2'}
                    antigen2Value={props.data.hlaDqa2}
                    alleles={alleles.filter(x => x.locusGroup == HlaLocusGroup.Dqa1)}
                    antigenOptions={dqaAntigens.antigens}
                    title={'DQA'}
                    antigenLabel={true}
                    equivalentSignedOff={props.data.hlaDiscrepancyIsEquivalent}
                    handleAntigenChange={handleNumberChange}
                />

                <HlaAntigenSelectionForm
                    antigen1Name={'hlaDqb1'}
                    antigen1Value={props.data.hlaDqb1}
                    antigen2Name={'hlaDqb2'}
                    antigen2Value={props.data.hlaDqb2}
                    alleles={alleles.filter(x => x.locusGroup == HlaLocusGroup.Dqb1)}
                    antigenOptions={dqAntigens.antigens}
                    title={'DQB'}
                    antigenLabel={true}
                    equivalentSignedOff={props.data.hlaDiscrepancyIsEquivalent}
                    handleAntigenChange={handleNumberChange}
                />

                <HlaAntigenSelectionForm
                    antigen1Name={'hlaDpb1'}
                    antigen1Value={props.data.hlaDpb1}
                    antigen2Name={'hlaDpb2'}
                    antigen2Value={props.data.hlaDpb2}
                    alleles={alleles.filter(x => x.locusGroup == HlaLocusGroup.Dpb1)}
                    antigenOptions={dpAntigens.antigens}
                    title={'DPB'}
                    antigenLabel={true}
                    equivalentSignedOff={props.data.hlaDiscrepancyIsEquivalent}
                    handleAntigenChange={handleNumberChange}
                />
                    </Panel.Body>
                </Panel>
            </Col>
        </>
    )
}

export default HLAClass2;